/**
 * @description: 仓库管理-库存盘点
 * @author: ccy
 * @update: hwx
 * @update: lyr(2022-03-16)
 */
<template>
    <div class="stock-checks">
        <div class="checks-list" v-show="!showDetail">
            <div class="row row-margin" v-show="showAddbtn">
                <button class="btn btn-flat btn-middle btn-orange" @click="addChecks">新增盘点单</button>
            </div>
            <div class="row">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="time">
                        <input type="text" class="form-control laydate-icon" :value="startTime"> -
                        <input type="text" class="form-control laydate-icon" :value="endTime">
                    </div>
                </div>
                <label class="list-label-4">门店名称:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="checks_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="checks_stock" data-placeholder="请选择仓库"></select>
                </div>
                <button type="button" class="btn btn-flat btn-small btn-border-orange btn-orange pull-right" @click="queryChecks">查询</button>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="checks_list"></table>
            </div>
        </div>
        <div class="checks-det" v-show="showDetail">
            <div class="row checks-det-top">
                <div v-show="showAdd">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" v-show="btnClickable" @click="clearStore">实际库存清零</button>
                    <button type="button" class="btn btn-flat btn-middle btn-gray" v-show="!btnClickable" disabled>实际库存清零</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" v-show="btnClickable" @click="getChecksGoods">获取系统实时库存数</button>
                    <button type="button" class="btn btn-flat btn-middle btn-gray" v-show="!btnClickable" disabled>获取系统实时库存数</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" id="checkSave" v-show="btnClickable" @click="addSave">保存</button>
                    <button type="button" class="btn btn-flat btn-middle btn-gray" v-show="!btnClickable" disabled>保存</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange"><a href="https://vodonline.g-hi.com/Download/stockTakingImportTemplate.xls">盘点单模板下载</a></button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="addXlsFun">导入盘点单</button>
                    <input type="file" @change="uploadXls($event)" ref="xlsFile" id="xlsFile">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="addExport">导出</button>
                </div>
                <div v-show="!showAdd">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="getExportSet">导出</button>
                </div>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="backList">返回</button>
            </div>
            <p>注：1、进货价合计=进货单价*盈亏数量<br />2、盘点总额=进货价合计的总和<br />3、结束时间如果不填写系统实时库存获取当下库存，如果填写的话获取填写时间点的系统实时库存<br />4、操作实际库存清零并保存后，对应条件下商品实时库存将全部为0</p>
            <div class="checks-det-list clearfix">
                <h2 v-show="showAdd">新增盘点单</h2>
                <h2 v-show="!showAdd">盘点单详情</h2>
                <div class="row row-margin">
                    <label class="col-md-1" v-show="showAdd">开始时间：</label>
                    <span class="col-md-4" v-show="showAdd">{{add_start_time}}</span>
                    <label class="col-md-1" v-show="!showAdd">单号：</label>
                    <span class="col-md-4" v-show="!showAdd">{{theDet.number}}</span>
                    <label class="col-md-1">盘点数量：</label>
                    <span class="col-md-2" v-text="checks_total"></span>
                    <label class="col-md-1">仓库：</label>
                    <div class="col-md-3 ct-col" v-show="showAdd">
                        <select class="form-control" data-placeholder="请选择仓库" ref="add_stock"></select>
                    </div>
                    <span class="col-md-3" v-show="!showAdd">{{theDet.store_name}}</span>
                </div>
                <div class="row row-margin">
                    <label class="col-md-1" v-show="showAdd">结束时间：</label>
                    <div class="col-md-4" v-show="showAdd">
                        <div ref="stTime">
                            <input type="text" class="form-control laydate-icon" v-model="add_end_time" placeholder="请选择盘点结束时间">
                        </div>
                    </div>
                    <label class="col-md-1" v-show="!showAdd">时间：</label>
                    <span class="col-md-4" v-show="!showAdd">{{theDetTime}}</span>
                    <label class="col-md-1">门店：</label>
                    <div class="col-md-2 ct-col" v-show="showAdd">
                        <select class="form-control" data-placeholder="请选择门店" ref="add_shop"></select>
                    </div>
                    <span class="col-md-2" v-show="!showAdd">{{theDet.shop_name}}</span>
                    <label class="col-md-1" v-show="showAdd">商品：</label>
                    <div class="col-md-3" v-show="showAdd">
                        <input class="form-control input-readonly" v-model="add_type_txt" ref="add_type_txt" placeholder="请选择商品" readonly @click="addTypeFun()">
                        <span class="selection-clear">×</span>
                        <span class="span-arrow"><b></b></span>
                    </div>
                    <!-- <span class="col-md-3" v-show="!showAdd">{{theDet.goods_type_name}}</span> -->
                </div>
                <div class="row">
                    <label class="col-md-1" v-show="!showAdd">盘点总额：</label>
                    <span class="col-md-4" v-show="!showAdd">{{theDetAmount}}</span>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="checks_det_list"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="export_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
                            <label>商品单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="system_stock">
                            <label>系统实时库存</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="actual_stock">
                            <label>实际库存</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="profit_loss">
                            <label>盈亏数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="amount">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="amount_total">
                            <label>进货价合计</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="remark">
                            <label>备注</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='export_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='export_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 添加商品弹窗 -->
            <div class="add-goods ele-hide" ref="type_alert">
                <el-radio-group v-model="pop_add_radio">
                    <el-radio :label="1">按商品</el-radio>
                    <el-radio :label="2">按商品分类</el-radio>
                </el-radio-group>
                <div class="by-goods" v-show="pop_add_radio=='1'">
                    <div class="row">
                        <div class="col-md-3 ct-col clear-pd">
                            <select class="form-control" data-placeholder="商品类型" ref="goodtype">
                                <option value=""></option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <input type="text" class="form-control" placeholder="请输入商品名称" ref="goodname" @keyup.13="queryGoods" />
                        </div>
                        <div class="pull-right">
                            <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryGoods">查询</button>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover" data-pagination="true" ref="goodslist"></table>
                    </div>
                    <!-- <div class="row btns">
                        <button type="button" class="btn btn-flat btn-small btn-orange pop-save" @click="saveGoods">保存</button>
                        <button type="button" class="btn btn-flat btn-small btn-gray" @click="closeLayer">取消</button>
                    </div> -->
                </div>
                <div class="by-types" v-show="pop_add_radio=='2'">
                    <div class="multi-select">
                        <div class="clearfix">
                            <input type='checkbox' v-model='type_all' @click='typeCheckAll'>
                            <span>全选</span>
                        </div>
                        <ul class="clearfix">
                            <li v-for="item in type_arr">
                                <input type="checkbox" v-model='type_item' :value="item.id">
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import XLSX from 'xlsx';
    export default {
        name: 'procurement_return',
        data () {
            return {
                menu_show: false,
                showDetail: false,
                showAddbtn: false,
                showAdd: false,
                btnClickable: false,
                startTime: "",
                endTime: "",

                add_start_time: '',
                add_end_time: '',
                add_type_txt: "",
                type_all: false,
                c_type_all: false,
                type_item: [],
                type_arr: [],

                det_id: '',
                theDet: [],
                theDetTime: "",
                checks_total: '0',
                theDetAmount: '',
                checks_goods_list: [],
                // remarkList: [],
                export_allcheck: false,
                c_export_allcheck: false,
                export_checkModel: [],
                export_checkData: ['goods_name', 'goods_unit_name', 'goods_type_name', 'system_stock', 'actual_stock', 'profit_loss', 'amount', 'amount_total', 'remark'],
                export_type: 1,

                pop_add_radio: 1,
                goodsType_list: [],
            }
        },
        watch: {
            export_checkModel: {
                handler: function(val, oldVal) {
                    if(this.export_checkModel.length >= this.export_checkData.length) {
                        this.export_allcheck = true;
                        this.c_export_allcheck = true;
                    } else {
                        this.export_allcheck = false;
                        this.c_export_allcheck = false;
                    }
                },
                deep: true
            },
            checks_goods_list: {
                handler: function(val, oldVal) {
                    if(val.length > 0) {
                        this.btnClickable = true;
                    } else {
                        this.btnClickable = false;
                    }
                },
                deep: true
            },
            type_item: {
                handler: function(val, oldVal) {
                    if(this.type_item.length >= this.type_arr.length) {
                        this.type_all = true;
                        this.c_type_all = true;
                    } else {
                        this.type_all = false;
                        this.c_type_all = false;
                    }
                },
                deep: true
            },
        },
        mounted() {
            this.getMunu();
            // 日期
            this.startTime = moment().format('YYYY-MM-DD 08:00');
            this.endTime = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            this.getShop();
            this.getGoodsType();
        },
        methods: {
            // 获取菜单
            getMunu: function() {
                let menu = {};
                let _this = this;
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    $.each(menu, function(k, v) {
                        if(v.id == '543') {
                            menu = v.submenu;
                            $.each(menu, function(m, n) {
                                if(n.id == '563') {
                                    menu = n.submenu;
                                    _this.menu_show = false;
                                    _this.showAddbtn = false;
                                    $.each(menu, function(m, n) {
                                        if(n.id == '646') {
                                            _this.menu_show = true;
                                        }
                                        if(n.id == '659') {
                                            _this.showAddbtn = true;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;

                $(_this.$refs.time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate()
                }, function(start, end, label) {
                    _this.startTime = start.format('YYYY-MM-DD HH:mm');
                    _this.endTime = end.format('YYYY-MM-DD HH:mm');
                });
                // 取消按钮
                $(_this.$refs.time).on('cancel.daterangepicker', function(ev, picker) {
                    // _this.startTime = "";
                    // _this.endTime = "";
                    console.log(ev);
                    console.log(picker);
                });
            },
            // 获取门店
            getShop: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.checks_shop).select2({
                                data: arr,
                                allowClear: true,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.checks_stock).val("").trigger("change");
                                    $(_this.$refs.checks_stock).prop("disabled", true);
                                    return;
                                }
                                // $(_this.$refs.checks_stock).val("").trigger("change");
                                $(_this.$refs.checks_stock).prop("disabled", false);
                                _this.getStock(e.params.data.id, 'list');
                            });
                            // 默认门店
                            $(_this.$refs.checks_shop).val(data.response.result[1].id).trigger('change');
                            // 仓库
                            // $(_this.$refs.checks_stock).val("").trigger("change");
                            $(_this.$refs.checks_stock).prop("disabled", false);
                            _this.getStock($(_this.$refs.checks_shop).val(), 'list');

                            arr.shift();
                            $(_this.$refs.add_shop).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                _this.getStock(e.params.data.id);
                            });
                            
                            _this.initTable();
                        } else {
                           Vue.timeoutfun(data.response.result_status,_this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取仓库数据
            getStock: function(shop_id, type) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            shop_id: shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            if(type == 'list') {
                                $(_this.$refs.checks_stock).html("");
                                $(_this.$refs.checks_stock).select2({
                                    data: arr,
                                    language: "zh-CN",
                                    width: '100%'
                                });
                                return;
                            }

                            arr.shift();
                            $(_this.$refs.add_stock).html("");
                            $(_this.$refs.add_stock).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function (e) {
                                // 获取开始时间
                                _this.getStartTime();
                                _this.checks_total = 0;
                                _this.add_type_txt = '';
                                _this.type_item = [];
                                $(_this.$refs.checks_det_list).bootstrapTable('destroy');
                                _this.checks_goods_list = [];
                            });
                            // 获取开始时间
                            _this.getStartTime();
                            _this.checks_total = 0;
                            _this.add_type_txt = '';
                            _this.type_item = [];
                            $(_this.$refs.checks_det_list).bootstrapTable('destroy');
                            _this.checks_goods_list = [];
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取开始时间
            getStartTime: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.add_shop).val(),
                            "store_id": $(_this.$refs.add_stock).val()
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getInfoBeforeTaking",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.add_start_time = data.response.result.last_time;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取商品类型
            getGoodsType: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.type_arr = data['response']['result']['data'];
                            _this.goodsType_list.push({
                                id: "0",
                                text: "全部"
                            });
                            $.each(data.response.result.data, function(k, v) {
                                _this.goodsType_list.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.goodtype).select2({
                                allowClear: true,
                                data: _this.goodsType_list
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 初始化列表
            initTable: function() {
                let _this = this;
                
                $(_this.$refs.checks_list).bootstrapTable('destroy');
                $(_this.$refs.checks_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    ajax: function(params) {
                        _this.getList(params);
                    },
                    sidePagination: "server",
                    pagination: true,
                    columns: [{
                        field: "updated_at",
                        title: "操作时间",
                        width: "16%"
                    }, {
                        field: "number",
                        title: "盘点单号",
                        width: "16%"
                    }, {
                        field: "create_time",
                        title: "盘点日期",
                        width: "18%"
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "15%"
                    }, {
                        field: "store_name",
                        title: "盘点仓库",
                        width: "10%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "10%"
                    }, {
                        title: "操作",
                        width: "15%",
                        events: {
                            'click .detail': function(e, value, row, index) {
                                _this.showAdd = false;
                                _this.det_id = row.id;
                                _this.getDeteil();
                                _this.showDetail = true;
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue detail">详情</span>';
                        }
                    }]
                })
            },
            // 列表
            getList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.startTime,
                            "end_time": _this.endTime,
                            "shop_id": $(_this.$refs.checks_shop).val(),
                            "store_id": $.trim($(_this.$refs.checks_stock).val())
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/searchStockTakingList",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.data.total,
                                rows: data.response.result.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 查询
            queryChecks: function() {
                this.initTable();
            },
            // 新增盘点单
            addChecks: function() {
                let _this = this;

                _this.showAdd = true;
                _this.checks_total = 0;
                $(_this.$refs.add_shop).val('').trigger("change");
                _this.getStock($(_this.$refs.add_shop).val());
                _this.add_end_time = '';
                _this.initEndCalendar();
                _this.add_type_txt = '';
                _this.type_item = [];
                $(_this.$refs.checks_det_list).bootstrapTable('destroy');
                _this.checks_goods_list = [];
                // _this.remarkList = [];
                _this.showDetail = true;
                $(_this.$refs.add_type_txt).prop('disabled', false);
            },
            // 初始化结束时间日历
            initEndCalendar: function() {
                let _this = this;
                let oldEndTime = ''
                $(_this.$refs.stTime).daterangepicker({
                    parentEl: '.st-endtime',
                    singleDatePicker: true, // 设置成单日历
                    drops: 'up',
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    maxDate: moment(new Date())
                }, function(start, end, label) {
                    let newEndTime = start.format('YYYY-MM-DD 08:00');
                    if(newEndTime !== oldEndTime) {
                        _this.add_end_time = start.format('YYYY-MM-DD 08:00');
                        oldEndTime = newEndTime
                        _this.getChecksGoodsAfterChangeEndTime()
                    }
                    
                });
            },
            // 新增导出
            addExport() {
                let _this = this;

                if(_this.type_item.length == '0') {
                    layer.msg("请选择商品类型");
                    return;
                }
                let top = [
                    ['新增盘点单', null, null, null, null, null, null, null],
                    ['开始时间：'+ _this.add_start_time +'', null, null, '盘点数量：'+ _this.checks_total +'', null, '仓库：'+ $(_this.$refs.add_stock).find("option:selected").text() +'', null, null],
                    ['结束时间：'+ _this.add_end_time +'', null, null, '门店：'+ $(_this.$refs.add_shop).find("option:selected").text() +'', null, '商品类型：'+ _this.add_type_txt +'', null, null],
                    [null, null, null, null, null, null, null, null],
                    ["序号", "商品名称", "商品单位", "商品类型", "系统实时库存", "实际库存", "盈亏数量", "备注"]
                ];
                let goods = [];
                $.each(_this.checks_goods_list, function(k, v) {
                    goods.push({
                        "序号": k + 1,
                        "商品名称": v.goods_name,
                        "商品单位": v.goods_unit_name,
                        "商品类型": v.goods_type_name,
                        "系统实时库存": v.system_stock,
                        "实际库存": v.actual_stock,
                        "盈亏数量": v.profit_loss,
                        "备注": v.remark
                    });
                    top.push([k + 1, v.goods_name, v.goods_unit_name, v.goods_type_name, v.system_stock, v.actual_stock, v.profit_loss, v.remark]);

                });
                let sheet1 = XLSX.utils.json_to_sheet(goods);
                let sheet2 = XLSX.utils.aoa_to_sheet(top);
                let sheet3 = sheet1 + sheet2;
                console.log(top);
                let workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, sheet2, '盘点单');
                XLSX.writeFile(workbook, '盘点单'+ moment().format('YYYYMMDDHHmmss') +'.xls'); // 导出Excel

                // console.log(sheet);

                // var data = [[1,2,3],[true, false, null, "sheetjs"],["foo","bar",new Date("2014-02-19T14:30Z"), "0.3"], ["baz", null, "qux"]];  //数据，一定注意需要时二维数组
                // var ws_name = "Sheet1"; //Excel第一个sheet的名称
                // var wb = XLSX.utils.book_new(), ws = XLSX.utils.aoa_to_sheet(data);
                // XLSX.utils.book_append_sheet(wb, ws, ws_name);  //将数据添加到工作薄
                // XLSX.writeFile(wb, '盘点单.xls'); //导出Excel

                // let goods = [];
                // $.each(_this.checks_goods_list, function(k, v) {
                //     goods.push({
                //         "goods_name": v.goods_name,
                //         "goods_unit_name": v.goods_unit_name,
                //         "goods_type_name": v.goods_type_name,
                //         "system_stock": v.system_stock,
                //         "actual_stock": v.actual_stock,
                //         "profit_loss": v.profit_loss,
                //         "remark": v.remark
                //     });
                // });
                // let datas = {
                //     "header": Vue.request_header,
                //     "request": {
                //         "version": Vue.version,
                //         "param": {
                //             "shop_name": $(_this.$refs.add_shop).find("option:selected").text(),
                //             "store_name": $(_this.$refs.add_stock).find("option:selected").text(),
                //             "goods_type_name": _this.add_type_txt.split(),
                //             "create_time": moment(_this.add_start_time).valueOf(),
                //             "last_time": moment(_this.add_end_time).valueOf() || '',
                //             "goods": goods
                //         }
                //     },
                //     "comment": []
                // };
                // let datas2 = JSON.stringify(datas);
                // $.ajax({
                //     type: "post",
                //     dataType: "json",
                //     url: Vue.ctUrl + "stock/stockTakingExportBeforeSaved",
                //     data: {
                //         json: datas2
                //     },
                //     crossDomain: true,
                //     xhrFields: {
                //         withCredentials: true
                //     },
                //     success: function(data) {
                //         if(data.response.result_code == "true") {
                //             console.log(data.response);
                //         } else {
                //             Vue.timeoutfun(data.response.result_status,_this);
                //             layer.msg(data.response.error_msg);
                //         }
                //     },
                //     error: function(err) {
                //         layer.msg("网络错误");
                //     }
                // });
            },
            // 点击选择商品类型
            addTypeFun: function(e) {
                let _this = this;
                let c_type_item = _this.type_item;
                _this.pop_add_radio = 1
                $(_this.$refs.goodtype).val("").trigger("change");
                $(_this.$refs.goodname).val("");
                _this.innitGoodsTable();
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['商品类型', true],
                    area: ['820px', '600px'], // 宽高
                    content: $(_this.$refs.type_alert),
                    cancel: function() {
                        // 右上角关闭
                        // _this.type_item = c_type_item;
                    }
                }, function() {
                    if (_this.pop_add_radio == '1') { // 按商品
                        _this.saveGoods()
                    }else { // 按商品分类
                        if(_this.type_item.length > 0) {
                            _this.getChecksGoods();
                            $(_this.$refs.checks_det_list).bootstrapTable('showColumn', 'op');
                            // $(".editicon").show();
                        } else {
                            _this.checks_total = 0;
                            $(_this.$refs.checks_det_list).bootstrapTable('destroy');
                            _this.checks_goods_list = [];
                        }
                    }
                }, function() {
                    // _this.type_item = c_type_item;
                });
            },
            // 初始化添加进货商品弹窗的商品列表
            innitGoodsTable: function() {
                let _this = this;
                $(_this.$refs.goodslist).bootstrapTable('destroy');
                $(_this.$refs.goodslist).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 5,
                    pageList: [5,10,20,30,50,100],
                    pagination: true,
                    height: 350,
                    ajax: function(params) {
                        _this.getGoodsList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        checkbox: true,
                        title: "全选"
                    }, {
                        field: "goods_type_name",
                        title: "类型"
                    }, {
                        field: "goods_name",
                        title: "名称"
                    }, {
                        field: "goods_unit_name",
                        title: "单位"
                    }],
                    clickToSelect: true
                });
            },
            // 获取商品列表
            getGoodsList: function(params) {
                let _this = this,
                    goods_type_str = $(_this.$refs.goodtype).val(),
                    goods_name = $(_this.$refs.goodname).val(),
                    pageNumber = 1;
                let goods_type = (goods_type_str == '' || goods_type_str == '0') ? [] : [goods_type_str];
                if(params.data.offset != 0) {
                    pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.add_shop).val(), // 门店id
                            "store_id": $(_this.$refs.add_stock).val(), // 仓库id
                            "goods_type": goods_type, // 商品类型
                            "goods_name": goods_name,
                            "end_time": _this.add_end_time,
                            "page": pageNumber,
                            "page_size": params.data.limit,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getStockInfo",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.data.total,
                                rows: data.response.result.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 点击新增进货商品弹窗的“查询”按钮
            queryGoods: function() {
                this.innitGoodsTable();
            },

            // 点击新增进货商品弹窗的“保存”按钮
            saveGoods: function() {
                let _this = this;
                let result = $(_this.$refs.goodslist).bootstrapTable('getSelections');
                if (result.length < 1) {
                    layer.msg("请先选择商品")
                    return
                }

                $.map(result, function(row) {
                    for(let i = 0; i < _this.checks_goods_list.length; i++) {
                        if(_this.checks_goods_list[i].merchant_goods_id == row.merchant_goods_id) {
                            layer.msg("商品已存在");
                            return;
                        }
                    }
                    // 默认实际库存
                    row.actual_stock = row.system_stock;
                    // 默认盈亏数量
                    row.profit_loss = Number(row.actual_stock) - Number(row.system_stock);
                    row.remark = '';
                    _this.checks_goods_list.push(row)
                    layer.msg("成功添加商品");
                })
                _this.initGoodsTable();

                _this.checksTotal();
            },

            // 商品类型全选
            typeCheckAll: function() {
                let _this = this;
                _this.type_all = _this.c_type_all;
                if(!_this.type_all) { // 实现全选
                    _this.type_item = [];
                    _this.type_arr.forEach(function(item) {
                        _this.type_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.type_item = [];
                }
            },
            // 实际库存清零
            clearStore() {
                this.checks_goods_list.forEach((v, k) => {
                    this.checks_goods_list[k].actual_stock = 0
                });
                // 刷新滚动条不变
                let scollPostion = $('.tab-content').scrollTop();
                $(this.$refs.checks_det_list).bootstrapTable('refreshOptions', {});
                $('.tab-content').scrollTop(scollPostion);
                this.checksTotal();
            },
            // 获取盘点商品
            getChecksGoods: function () {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.add_shop).val(), // 门店id
                            "store_id": $(_this.$refs.add_stock).val(), // 仓库id
                            "goods_type": _this.type_item, // 商品类型
                            "end_time": _this.add_end_time,
                            "page": 0,
                            "page_size": 0,
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getStockInfo",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data.rows;
                            $.map(result, function(row) {
                                for(let i = 0; i < _this.checks_goods_list.length; i++) {
                                    if(_this.checks_goods_list[i].merchant_goods_id == row.merchant_goods_id) {
                                        layer.msg("商品已存在");
                                        return;
                                    }
                                }
                                // 默认实际库存
                                row.actual_stock = row.system_stock;
                                // 默认盈亏数量
                                row.profit_loss = Number(row.actual_stock) - Number(row.system_stock);
                                row.remark = '';
                                _this.checks_goods_list.push(row)
                                layer.msg("成功添加商品");
                            })
                            // for(let i = 0 ; i < result.length; i++ ) {
                            //     // 默认实际库存
                            //     result[i].actual_stock = result[i].system_stock;
                            //     // 默认盈亏数量
                            //     result[i].profit_loss = Number(result[i].actual_stock) - Number(result[i].system_stock);
                            //     result[i].remark = '';
                            // }
                            // _this.checks_goods_list = result;
                            _this.initGoodsTable();

                            _this.checksTotal();
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            // 更改盘点结束时间后重新获取盘点商品库存
            getChecksGoodsAfterChangeEndTime: function () {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.add_shop).val(), // 门店id
                            "store_id": $(_this.$refs.add_stock).val(), // 仓库id
                            "end_time": _this.add_end_time,
                            "goods_ids": _this.checks_goods_list.map(item => item.merchant_goods_id) || []
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getGoodsStockInfo",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.checks_goods_list = []
                            let result = data.response.result.data;
                            $.map(result, function(row) {
                                // 默认实际库存
                                row.actual_stock = row.system_stock;
                                // 默认盈亏数量
                                row.profit_loss = Number(row.actual_stock) - Number(row.system_stock);
                                row.remark = '';
                                _this.checks_goods_list.push(row)
                                layer.msg("系统实时库存已更新，请重新输入实际库存数量！");
                            })
                            _this.initGoodsTable();
                            _this.checksTotal();
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            // 初始化详情列表
            initGoodsTable: function(pageNumber) {
                let _this = this;

                $(_this.$refs.checks_det_list).bootstrapTable('destroy');
                $(_this.$refs.checks_det_list).bootstrapTable({
                    pageNumber: pageNumber || 1,
                    pageSize: 5,
                    pageList: [],
                    columns: [{
                        field: "goods_name",
                        title: "商品名称",
                        width: "13%"
                    }, {
                        field: "goods_unit_name",
                        title: "商品单位",
                        width: "8%"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "10%"
                    }, {
                        field: "system_stock",
                        title: "系统实时库存",
                        width: "10%"
                    }, {
                        field: "actual_stock",
                        title: "实际库存",
                        width: "13%",
                        events: {
                            'click .editableicon': function(e, value, row, index) {
                                $(this).prev().addClass("editableinput-focus");
                                $(this).prev().attr("contenteditable", true);
                                $(this).addClass("editableiconend");
                                $(this).prev().focus();
                            },
                            'keypress .editableinput': function(e, value, row, index) {
                                if(event.keyCode == "13") {
                                    $(this).blur();
                                }
                            },
                            'blur .editableinput': function(e, value, row, index) {
                                $(this).removeClass("editableinput-focus");
                                $(this).attr("contenteditable", false);
                                $(this).next().removeClass("editableiconend");
                                let num = $(this).text();
                                if(isNaN(num)) {
                                    layer.msg("请输入数字");
                                    $(this).text(value);
                                    return;
                                }
                                if(num.split('.')[1] && num.split('.')[1].length > '2') {
                                    num = new Big(num).toFixed(4);
                                }
                                let profit_loss = new Big(num).minus(row.system_stock);
                                let amount_total = (profit_loss * row.amount).toFixed(4);
                                $(this).parent().next().find(".profit_loss").text(profit_loss);
                                $(this).parent().next().find(".amount_total").text(amount_total);
                                for(let i = 0; i < _this.checks_goods_list.length; i++) {
                                    if(row.id == _this.checks_goods_list[i].id) {
                                        _this.checks_goods_list[i].actual_stock = num;
                                        _this.checks_goods_list[i].profit_loss = profit_loss;
                                        _this.checks_goods_list[i].amount_total = amount_total;
                                    }
                                }
                                _this.checks_goods_list[index].have_edited = true 
                                // 刷新滚动条不变
                                let scollPostion = $('.el-tabs__content').scrollTop();
                                $(_this.$refs.checks_det_list).bootstrapTable('refreshOptions', {});
                                $('.el-tabs__content').scrollTop(scollPostion);
                                _this.checksTotal();
                            }
                        },
                        formatter: function(value, row, index) {
                            if(!_this.showAdd) {
                                return value;
                            } else {
                                if (!_this.menu_show && !row.have_edited) {
                                     return [
                                        '<div class="editableinput" contenteditable="false">0</div>' +
                                        '<a class="editableicon"></a>'
                                    ].join('');
                                }else {
                                    return [
                                        '<div class="editableinput" contenteditable="false">'+ value +'</div>' +
                                        '<a class="editableicon"></a>'
                                    ].join('');
                                }
                            }
                        }
                    }, {
                        field: "profit_loss",
                        title: "盈亏数量",
                        width: "8%"
                    }, {
                        field: "amount",
                        title: "进货单价",
                        width: "13%"
                    }, {
                        field: "amount_total",
                        title: "进货价合计",
                        width: "8%"
                    }, {
                        field: "remark",
                        title: "备注",
                        width: "10%",
                        events: {
                            'blur .remark': function(e, value, row, index) {
                                _this.checks_goods_list[index].remark = $.trim($(this).val());
                                let remark = $.trim($(this).val())
                                $(_this.$refs.checks_det_list).bootstrapTable("updateCell",{index:index,field:'remark',value:remark,reinit:false});
                                // _this.remarkList[index] = {
                                //     "merchant_goods_id": _this.checks_goods_list[index].merchant_goods_id,
                                //     "system_stock": Number(_this.checks_goods_list[index].system_stock),
                                //     "actual_stock": _this.checks_goods_list[index].actual_stock,
                                //     "isshow": _this.remarkList[index].isshow,
                                //     "amount": _this.remarkList[index].amount,
                                //     "remark": $.trim($(this).val())
                                // };
                            }
                        },
                        formatter: function(value, row, index) {
                            if(!_this.showAdd) {
                                return row.remark;
                            } else {
                                return [
                                    '<input type="text" placeholder="请输入备注" class="remark" value="'+ value + '" />'
                                ].join('');
                            }
                        }
                    }, {
                        field: "op",
                        title: "操作",
                        width: "8%",
                        events: {
                            'click .delete': function (e, value, row) {
                                layer.confirm('确认删除' + row.goods_name + '吗？', {
                                    btn: ['确定', '取消'] // 按钮
                                }, function() {
                                    for(let i = 0; i < _this.checks_goods_list.length; i++ ) {
                                        if(row.id == _this.checks_goods_list[i].id) {
                                            _this.checks_goods_list.splice(i, 1);
                                            // _this.remarkList.splice(i, 1);

                                            // 刷新滚动条不变
                                            let scollPostion = $('.el-tabs__content').scrollTop();
                                            _this.initGoodsTable($(_this.$refs.checks_det_list).bootstrapTable('getOptions').pageNumber);
                                            $('.el-tabs__content').scrollTop(scollPostion);

                                            _this.checksTotal();
                                            break;
                                        }
                                    }
                                    layer.closeAll();
                                });
                            }
                        },
                        formatter: function (value, row, index) {
                            return '<span class="text-blue delete">删除</span>'
                        }
                    }],
                    data: _this.checks_goods_list,
                    // onPageChange: function(num, size) {
                    //     for(let i = (num - 1) * 5; i < _this.remarkList.length; i++) {
                    //         $('.remark').eq(i - (num - 1) * 5).val(_this.remarkList[i].remark);
                    //     }
                    // }
                });
                // 实时库存和盈亏数量权限控制
                if(!_this.menu_show) {
                    $(_this.$refs.checks_det_list).bootstrapTable('hideColumn', 'system_stock');
                    $(_this.$refs.checks_det_list).bootstrapTable('hideColumn', 'profit_loss');
                }
                // 隐藏进货单价和进货价合计
                // if(_this.showAdd) {
                //     $(_this.$refs.checks_det_list).bootstrapTable('hideColumn', 'amount');
                //     $(_this.$refs.checks_det_list).bootstrapTable('hideColumn', 'amount_total');
                // }
            },
            // 盘点数量
            checksTotal: function() {
                let _this = this;
                let count = 0;
                for(let i = 0; i < _this.checks_goods_list.length; i++ ) {
                    count = new Big(count).plus(_this.checks_goods_list[i].actual_stock);
                }
                _this.checks_total = count;
            },
            // 保存新增盘点单
            addSave: function() {
                let _this = this;

                if(_this.checks_goods_list.length < 1) {
                    layer.msg("请选择商品");
                    return;
                }
                let goods = [];
                $.each(_this.checks_goods_list, function(k, v) {
                    goods.push({
                        "merchant_goods_id": v.merchant_goods_id,
                        "system_stock": v.system_stock,
                        "actual_stock": v.actual_stock,
                        "amount": v.purchase_amount,
                        "remark": v.remark
                    });
                });
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.add_shop).val(),
                            "store_id": $(_this.$refs.add_stock).val(),
                            "quantity": _this.checks_total,
                            "end_time": _this.add_end_time,
                            "goods_type": _this.type_item,
                            "goods": goods
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/addStockTaking",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $('#checkSave').prop('disabled', true);
                            layer.msg("添加成功！",{
                                time: 2000
                            });
                            _this.theDet.number = data.response.result.data.number;
                            _this.theDet.create_time = data.response.result.data.create_time;
                            setTimeout(function() {
                                _this.showDetail = false;
                                // _this.getShop();
                                _this.initTable();
                                $('#checkSave').prop('disabled', false);
                            }, 2000);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 返回列表
            backList: function() {
                this.showDetail = false;
            },
            // 盘点单顶部详情
            getDeteil: function(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": _this.det_id
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getStockTakingDetail",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            result.goods_type_name = result.goods_type_name.join(",");
                            _this.theDet = result;
                            _this.checks_total = result.quantity;
                            // 时间
                            _this.theDetTime = new Date(result.last_time * 1000).toLocaleString('chinese', {hour12:false}).replace(/(\/)/g, '-').replace(/年|月/g, "-").replace(/日/g, "") + '至' + new Date(result.create_time * 1000).toLocaleString('chinese', {hour12:false}).replace(/(\/)/g, '-').replace(/年|月/g, "-").replace(/日/g, "");
                            console.log(moment(parseInt(result.last_time)).format('YYYY-MM-DD hh:mm:ss'));
                            console.log(moment(parseInt(result.create_time)).format('YYYY-MM-DD hh:mm:ss'));
                            _this.getStockTakingGoods();
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 请求盘点单详情
            getStockTakingGoods: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "stocktaking_id": _this.det_id
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/getStockTakingGoods",
                    data: datas2,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.checks_goods_list = data.response.result.data.rows;
                            _this.initGoodsTable();
                            $(_this.$refs.checks_det_list).bootstrapTable('hideColumn', 'op');
                            _this.theDetAmount = data.response.result.data.amount_total;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "stock/StockTakingExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.export_alert)
                }, function() {
                    _this.exportDetail();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 导出
            exportDetail: function() {
                let export_fields = JSON.stringify(this.export_checkModel);
                window.location.href = Vue.ctUrl + "stock/StockTakingExport?" +
                    "id=" + this.det_id +
                    "&export_fields=" + export_fields +
                    "&export_type=" + this.export_type;
                layer.msg("导出成功！");
                layer.closeAll();
            },

            // 点击上传xls文件
            addXlsFun: function() {
                this.$refs.xlsFile.click();
            },
            // 上传
            uploadXls: function(e) {
                let _this = this;

                let formData = new FormData();
                formData.append("stockTakingFile", $("#xlsFile")[0].files[0]);
                // 清除file
                let obj = document.getElementById('xlsFile');
                obj.value = '';

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": $(_this.$refs.add_shop).val(),
                            "store_id": $(_this.$refs.add_stock).val(),
                            "end_time": _this.add_end_time,
                        }
                    },
                    "comment": ""
                };

                Vue.axios.post("stock/importStockTakingGoods?json=" + JSON.stringify(datas), formData, {
                    transformRequest: [function (data, headers) {
                        // 覆盖默认
                        return data;
                    }]
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('导入成功');
                        _this.type_item = res.data.response.result.goods_type;
                        _this.add_type_txt = res.data.response.result.goods_type_str;
                        _this.checks_total = res.data.response.result.quantity;
                        _this.checks_goods_list = []
                        $.map(res.data.response.result.rows, function(row) {
                            // 默认盈亏数量
                            row.profit_loss = (Number(row.actual_stock) - Number(row.system_stock)).toFixed(2);
                            _this.checks_goods_list.push(row)
                        })
                        _this.initGoodsTable();
                        $(_this.$refs.add_type_txt).prop('disabled', true); // 导入之后商品类型不可修改
                    } else {
                       Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.open({
                            type: 1,
                            title: '导入失败，数据错误，请修正数据后重新导入！',
                            skin: 'import-err',
                            area: ['700px', ''],
                            content: res.data.response.error_msg
                        })
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
        }
    }
</script>



<style lang="less">
    .stock-checks {
        .checks-det {
            .checks-det-top {
                div {
                    float: left;
                }
                button {
                    margin: 0 30px 0 0;
                }
                a {
                    text-decoration: none;
                    color: #fff;
                }
                #xlsFile {
                    display: none;
                }
            }
            p {
                margin: 30px 0 0;
                line-height: 22px;
                color: #f34747;
            }
            .checks-det-list {
                border-top: 8px solid #d7d7d7;
                padding: 0 50px 20px;
                margin: 30px 0;
                background: #f3f3f3;
                h2 {
                    margin: 20px 0;
                    font-size: 20px;
                    font-weight: normal;
                    text-align: center;
                }
                label {
                    height: 32px;
                    padding: 0;
                    margin: 0 0 0;
                    line-height: 32px;
                    font-size: 14px;
                    text-align: right;
                }
                >div {
                    >span {
                        min-height: 32px;
                        padding: 0;
                        line-height: 32px;
                        font-size: 14px;
                    }
                    >div {
                        padding-left: 0;
                    }
                }
            }
        }
        .set-export {
            padding: 0 20px 20px;
            h3 {
                font-size: 16px;
            }
            li {
                float: left;
                width: 20%;
            }
        }
        .add-goods {
            .select2 {
                width: 100%!important;
            }
            .el-radio-group {
                margin-bottom: 15px;
            }
        }
    }
</style>
